import { Grid, Typography, Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import digipasslogo from "../layouts/application layout components/assets/digipass-face.svg";

const CardButton = styled(Button)`
  margin-top: 10px;
  border-radius: 10px;
  border-color: #d9dee7;
  color: #1f2a44;
  text-transform: none;
  font-weight: 700;

  &:hover {
    border-color: #c4ccda;
    background: #f7f9fc;
  }
`;

function PassCard({ title, status, rows = [], onView, show = true, style }) {
  if (!show || !rows.length) {
    return null;
  }

  const normalizedStatus = (status || "").toLowerCase();
  const isPending = normalizedStatus.includes("pending");

  const primaryValue = rows[0]?.value || "";
  const footerValue =
    rows.length > 3 ? rows[rows.length - 1]?.value : rows[3]?.value || "";
  const secondaryRows = rows.length > 3 ? rows.slice(1, -1) : rows.slice(1, 3);

  const statusLabel = status ? status.toUpperCase() : "";

  return (
    <Grid
      item
      container
      sx={{
        border: "1px solid #e3e8ef",
        borderRadius: "16px",
        padding: "14px !important",
        background: "#ffffff",
        boxShadow: "0 1px 0 rgba(16, 24, 40, 0.02)",
        marginBottom: "10px",
        position: "relative",
        overflow: "hidden",
        ...style,
      }}
      onClick={onView}
    >
      <Grid
        item
        container
        m="0px 0px 4px"
        justifyContent="space-between"
        alignItems="center"
        onClick={onView}
      >
        <Typography
          variant="caption"
          sx={{
            fontSize: "10px",
            letterSpacing: "0.08em",
            color: "#98a2b3",
            fontWeight: 800,
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        {status && (
          <Typography
            variant="caption"
            sx={{
              backgroundColor: isPending ? "#fff4e5" : "#e7f8ef",
              color: isPending ? "#b54708" : "#027a48",
              padding: "4px 10px",
              borderRadius: "999px",
              fontWeight: 800,
              textTransform: "uppercase",
              fontSize: "10px",
              lineHeight: "12px",
            }}
          >
            {statusLabel}
          </Typography>
        )}
      </Grid>

      <Grid item xs={12} sx={{ mb: 1.2 }}>
        <Typography
          variant="caption"
          sx={{
            fontSize: "16px",
            lineHeight: "30px",
            fontWeight: 900,
            color: "#101828",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {primaryValue}
        </Typography>
      </Grid>

      <Grid
        item
        container
        xs={12}
        alignItems="flex-end"
        justifyContent="space-between"
      >
        <Grid
          item
          sx={{
            display: "flex",
            gap: "12px 24px",
            flexWrap: "wrap",
            minWidth: 0,
            flex: 1,
          }}
        >
          {secondaryRows.map(({ label, value }) => (
            <Box
              key={label}
              sx={{ minWidth: "120px", flex: "1 1 calc(50% - 12px)" }}
            >
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  fontSize: "9px",
                  lineHeight: "12px",
                  letterSpacing: "0.07em",
                  color: "#98a2b3",
                  fontWeight: 800,
                  textTransform: "uppercase",
                  mb: 0.4,
                }}
              >
                {label}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  lineHeight: "22px",
                  color: "#344054",
                  fontWeight: 800,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Grid>

        <Grid item>
          {/* <QrCode2Icon sx={{ fontSize: 22, color: "#2f6bff" }} /> */}
          <img src={digipasslogo} alt="Digipass Logo" width="25" height="25" />
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ mt: 1 }}>
        <Typography
          variant="caption"
          sx={{
            fontSize: "10px",
            lineHeight: "12px",
            color: "#98a2b3",
            fontWeight: 700,
            letterSpacing: "0.02em",
          }}
        >
          ID: {footerValue}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default PassCard;
